<template>
  <pt-task-lot-operate class="pt-task-lot-operate__page"></pt-task-lot-operate>
</template>

<script>
import PtTaskLotOperate from 'cps/production-task/pt-task-lot-operate/withData'
export default {
  name: 'pt-task-lot-operate__view',
  components: {
    'pt-task-lot-operate': PtTaskLotOperate
  }
}
</script>
